import React, { useState } from "react";
import { Form } from "react-bootstrap";
import "./company.css";
import { DatePicker } from "antd";
import dayjs from "dayjs";

const CompanyDashboard = () => {
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("All");
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  return (
    <div className="filter-card p-3">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <button className="clear-btn-company">CLEAR FILTERS</button>
        <Form.Select className="filter-select w-auto">
          <option>From Beginning</option>
        </Form.Select>
      </div>

      <Form>
        <div className="row g-3">
          <div className="col-md-3">
            <Form.Group>
              <Form.Label>Search</Form.Label>
              <Form.Control
                type="text"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder="Search..."
              />
            </Form.Group>
          </div>

          <div className="col-md-3">
            <Form.Group>
              <Form.Label>Status</Form.Label>
              <Form.Select
                value={status}
                onChange={(e) => setStatus(e.target.value)}
              >
                <option>All</option>
                <option>Active</option>
                <option>Inactive</option>
              </Form.Select>
            </Form.Group>
          </div>

          <div className="col-md-3">
            <Form.Group>
              <Form.Label>From</Form.Label>
              <DatePicker
                className="form-control"
                value={fromDate ? dayjs(fromDate) : null}
                onChange={(date) =>
                  setFromDate(date ? date.format("YYYY-MM-DD") : null)
                }
                format="YYYY-MM-DD"
                allowClear
              />
            </Form.Group>
          </div>

          <div className="col-md-3">
            <Form.Group>
              <Form.Label>To</Form.Label>
              <DatePicker
                className="form-control"
                value={toDate ? dayjs(toDate) : null}
                onChange={(date) =>
                  setToDate(date ? date.format("YYYY-MM-DD") : null)
                }
                format="YYYY-MM-DD"
                allowClear
              />
            </Form.Group>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default CompanyDashboard;
